import React from 'react';
import PropTypes from 'prop-types';

const FooterButton = ({
  cancelText = 'Cancel',
  saveText = 'Save',
  onSave = null,
  onCancel = null,
  disableSave = false,
  disableCancel = false,
  saveBtnClass = '',
  hideSave = false,
}) => {
  return (
    <div className="col-lg-12">
      <div className="modal-footer-btn">
        <button
          type="button"
          className="btn btn-cancel me-1"
          onClick={onCancel}
          disabled={disableCancel}
        >
          {cancelText}
        </button>
        {!hideSave && <button
          className={`${saveBtnClass} btn btn-success me-1`}
          onClick={onSave}
          disabled={disableSave}
        >
          {saveText}
        </button>}
      </div>
    </div>
  );
};

FooterButton.propTypes = {
  cancelText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  saveBtnClass: PropTypes.string,
  saveText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  disableSave: PropTypes.bool,
  disableCancel: PropTypes.bool,
  hideSave: PropTypes.bool,
};

export default FooterButton;
